import { RouteProps } from 'react-router-dom'
import { BookPage } from '../../../pages/BookPage/BookPage'
import { AdminPage } from '../../../pages/AdminPage'
import LoginPage from '../../../pages/LoginPage/ui/LoginPage/LoginPage'
import { MainPage } from '../../../pages/MainPage/MainPage'
import { AppRoutes, ChildAppRoutes } from '../../lib/const/router'

export type AppRoutesProps = RouteProps & {
    authOnly?: boolean
    child?: Record<string | ChildAppRoutes, AppRoutesProps>
    roles?: any[]
}

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
    [AppRoutes.MAIN]: {
        path: '/',
        element: <MainPage />
    },
    [AppRoutes.BOOK]: {
        path: '/book',
        element: <BookPage />
    },
    [AppRoutes.LOGIN]: {
        path: '/login',
        element: <LoginPage />
    },
    [AppRoutes.ADMIN]: {
        path: '/admin',
        element: <AdminPage />,
        authOnly: true
    }
}
